import {createReducer} from "typesafe-actions";
import {SET_FAVORITES_COUNT} from "../actions";

export const favoritesCount = createReducer(0)
    .handleAction(SET_FAVORITES_COUNT, (state, action) => action.payload);
